import React, { useState } from "react";
import styles from "../Assets/css/confusedform.module.css";
import sidePic from "../Assets/img/course/confused_illustration.png";
import rightArrow from "../Assets/img/course/arrow-right-black.png";
import validator from "validator";
import Rectangle from "../Assets/img/Home/Rectangle 1036.png";
import useMedia from "./useMedia";
import { Alert } from "react-bootstrap";
import { BASE_URL } from "../env";
export function ConfusedForm(props) {
	const matches = useMedia("(min-width : 768px )");
	const [fullName, setfullName] = useState("");
	const [phoneNumber, setphoneNumber] = useState("");
	const [email, setEmail] = useState("");
	const [query, setQuery] = useState(props.coursename);
	const [graduationYear, setGraduationYear] = useState("");
	const [msg, setMsg] = useState("");
	const [showMsg, setShowMsg] = useState(" ");
	const [message, StatusMsg] = useState("");

	const [hide, setHide] = useState(false);
	const [loader, setLoader] = useState(false);
	// a9a7aa678f0fdd3188262fa2789105ef-us6
	// 66c8833143
	async function handleSubmit(event) {
		event.preventDefault();
		if (
			validator.isEmail(email) &&
			validator.isNumeric(phoneNumber) &&
			phoneNumber.length === 10 &&
			validator.isNumeric(graduationYear)
		) {
			setLoader(true);
			await fetch(BASE_URL + "/addQuery", {
				method: "POST",
				body: JSON.stringify({
					fullName,
					phoneNumber,
					email,
					query,
					graduationYear,
				}),
				headers: { "content-Type": "application/json" },
			})
				.then((response) => response.json())
				.then((data) => {
					console.log(data);
					StatusMsg(data.message);
					setShowMsg(true);
					setLoader(false);
					setHide(true);
				});
		} else {
			if (!validator.isEmail(email)) {
				setMsg("Email is not correct");
			} else if (
				!validator.isNumeric(phoneNumber) ||
				phoneNumber.length !== 10
			) {
				setMsg("Phone number is not correct");
			} else if (!validator.isNumeric(graduationYear)) {
				setMsg("Graduation year is not correct");
			}
			setShowMsg(true);
		}
	}

	return (
		<div className="pt-5 mt-5">
			<div className={styles.cpoutercontainer}>
				<div className={styles.cpleftcontainer}>
					<img
						className={styles.cpsidePic}
						src={props.set === 1 ? sidePic : Rectangle}
						alt=""
					/>
					<div
						className={`${styles.cpconfusedtext}  ${styles.outerconfusedcontainer}`}
					>
						<h2 className={styles.cpconfusedtextprim}>
							Confused ?
						</h2>
						<p className={styles.cpconfusedtextsecond}>
							Get Expert guidance!!!
						</p>
					</div>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<img
						className={styles.cprightarrow}
						src={rightArrow}
						alt=""
					/>
				</div>

				{hide === false ? (
					<div
						id="formRef"
						style={{
							marginRight: matches ? "10%" : null,
							marginLeft: matches ? "-8%" : null,
						}}
						className={styles.cprightcontainer}
					>
						<div
							className={`${styles.cpgetincontain} col-lg-4 col-md-12`}
						>
							<div className={styles.inpcontain}>
								<input
									onChange={(event) =>
										setfullName(event.target.value)
									}
									className={styles.yelloin}
									placeholder="First Name"
								/>
							</div>
							<div className={styles.inpcontain}>
								<input
									onChange={(event) =>
										setEmail(event.target.value)
									}
									className={styles.yelloin}
									placeholder="Email Address"
								/>
							</div>
							<div className={styles.inpcontain}>
								<input
									onChange={(event) =>
										setphoneNumber(event.target.value)
									}
									className={styles.yelloin}
									placeholder="Phone Number"
								/>
							</div>
							<div className={styles.inpcontain}>
								<input
									onChange={(event) =>
										setGraduationYear(event.target.value)
									}
									className={styles.yelloin}
									placeholder="Gradution Year"
								/>
							</div>
							{showMsg !== "" ? (
								<div style={{ color: "red" }}> {msg} </div>
							) : null}
							<div className={styles.inpcontain}>
								<input
									onClick={handleSubmit}
									className={styles.yelloinsub}
									type="submit"
									value={
										loader === false
											? "Get In Touch"
											: "Loading..."
									}
								/>
							</div>
						</div>
					</div>
				) : (
					//showMsg===success?'success':'danger'
					<Alert
						style={{
							marginTop: "5%",
							marginLeft: "5%",
							textAlign: "center",
							maxHeight: "150px",
							minWidth: "30%",
						}}
						variant={
							message === "Saved Query" ? "success" : "danger"
						}
					>
						<Alert.Heading>
							{message === "Saved Query"
								? "Success!"
								: "Error!!!"}
							{}
						</Alert.Heading>
						<hr />
						<p className="mb-0">
							{message === "Saved Query"
								? "We will reach you shortly"
								: message}
						</p>
					</Alert>
				)}
			</div>
		</div>
		// <div className="container-fluid outer-confused-container">
		//   <div>
		//     <div className="confused-container col-lg-8 col-md-12">
		//       <div className="cpconfusedtext">
		//         <h2 className="confused-text-prim">Confused ?</h2>
		//         <p className="confused-text-second">Get Expert guidance!!!</p>
		//       </div>{" "}
		//       <img className="confusion-arrow" src={rightArrow} alt="" />
		//     </div>
		//   </div>
		//   <div>
		//     <div className="cpgetincontain col-lg-4 col-md-12">
		//       <div className={styles.inpcontain}>
		//         <input className={styles.yelloin} placeholder="First Name" />
		//       </div>
		//       <div className={styles.inpcontain}>
		//         <input className={styles.yelloin} placeholder="Email Address" />
		//       </div>
		//       <div className={styles.inpcontain}>
		//         <input className={styles.yelloin} placeholder="Phone Number" />
		//       </div>
		//       <div className={styles.inpcontain}>
		//         <input className={styles.yelloin} placeholder="Gradution Year" />
		//       </div>
		//       <div className={styles.inpcontain}>
		//         <input className="yelloinsub" type="submit" value="Get In Touch" />
		//       </div>
		//     </div>
		//   </div>
		// </div>
	);
}

export default ConfusedForm;
